const lifeInsuranceTypeOptions = [{ id: 's_vida_vida', label: 'Seguro de Vida', value: 'vida' }, 
{ id: 's_vida_univ', label: 'Fondo universitario', value: 'fondo universitario' }]
export default lifeInsuranceTypeOptions